import axiosInstance from './axiosInstance';
import { InternalIssue, CreateInternalIssueDto, UpdateInternalIssueDto } from '../types/internalIssues.types';

const BASE = '/InternalIssues';

export const internalIssuesService = {
  getAll: async (
    status?: string, warehouseId?: number,
    fromDate?: string, toDate?: string
  ): Promise<InternalIssue[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (warehouseId) params.append('warehouseId', warehouseId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    const url = params.toString() ? `${BASE}?${params.toString()}` : BASE;
    return (await axiosInstance.get<InternalIssue[]>(url)).data;
  },

  getById: async (id: number): Promise<InternalIssue> =>
    (await axiosInstance.get<InternalIssue>(`${BASE}/${id}`)).data,

  create: async (dto: CreateInternalIssueDto): Promise<InternalIssue> =>
    (await axiosInstance.post<InternalIssue>(BASE, dto)).data,

  update: async (id: number, dto: UpdateInternalIssueDto): Promise<InternalIssue> =>
    (await axiosInstance.put<InternalIssue>(`${BASE}/${id}`, dto)).data,

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${BASE}/${id}`);
  },

  approve: async (id: number): Promise<InternalIssue> =>
    (await axiosInstance.post<InternalIssue>(`${BASE}/${id}/approve`)).data,

  reject: async (id: number, reason?: string): Promise<InternalIssue> =>
    (await axiosInstance.post<InternalIssue>(`${BASE}/${id}/reject`, { reason })).data,

  post: async (id: number): Promise<InternalIssue> =>
    (await axiosInstance.post<InternalIssue>(`${BASE}/${id}/post`)).data,

  unpost: async (id: number): Promise<InternalIssue> =>
    (await axiosInstance.post<InternalIssue>(`${BASE}/${id}/unpost`)).data,
};
